import { View } from 'react-native'
import { useTranslation } from 'react-i18next'
import Typography from '@ui/typography'
import Icon from '@ui/elements/Icon'
import { colors } from '@ui/colors'
import {
  PaymentMethod,
  PaymentMethodDisableReason,
  getMethodMinTotal,
} from '@ca/common'
import { usePrice } from 'hooks/useCurrency'

export default function DisableReasonItem({
  reason,
  method,
}: {
  reason: PaymentMethodDisableReason
  method: PaymentMethod
}) {
  const { t } = useTranslation(['modals'])
  const minPrice = usePrice(getMethodMinTotal(method))

  const text = t(`modals:checkout.paymentMethods.reasons.${reason}`, {
    minValue: minPrice,
  })

  return (
    <View className="flex flex-row items-center gap-2">
      <Icon name="exclamation-circle" size={16} color={colors.red[500]} />
      <Typography variant="XS" color={colors.red[500]}>
        {text}
      </Typography>
    </View>
  )
}
